import * as React from 'react';

import ActionLink from '../buttons/action-link/ActionLink';

import { __t, applyTranslations } from 'utils/language';

import './help-note.scss';

applyTranslations(require('./help-note.i18n.json'));

type Props = {
  message: string,
  link?: string,
  style?: any
};

class HelpNote extends React.PureComponent<Props> {
  render() {
    const { message, link, style } = this.props;

    return (
      <section className="help-note" style={style}>
        {message}
        {
          link &&
            <span className="help-note__link">
              <ActionLink
                inline
                openInNewTab
                color="secondary"
                size="inherit"
                decoration="none"
                link={link}
              >
                {__t('help_note.link')}
              </ActionLink>
            </span>
        }
      </section>
    );
  }
}

export default HelpNote;
